import { SignalWatcher, WithDisposable } from '@blocksuite/affine/global/lit';
import { ShadowlessElement } from '@blocksuite/affine/std';
import { PlayIcon } from '@blocksuite/icons/lit';
import { html } from 'lit';
import { property } from 'lit/decorators.js';

import type { AutomationAttachment } from '../ai-chat-content/type';

export class ChatPanelAutomationChip extends SignalWatcher(
  WithDisposable(ShadowlessElement)
) {
  @property({ attribute: false })
  accessor automation!: AutomationAttachment;

  @property({ attribute: false })
  accessor onRemove: ((automation: AutomationAttachment) => void) | undefined;

  override render() {
    const tooltip = this._getTooltip();

    return html`<chat-panel-chip
      .state=${'finished'}
      .name=${this.automation.name}
      .tooltip=${tooltip}
      .icon=${PlayIcon()}
      .closeable=${!!this.onRemove}
      .onChipDelete=${this._handleRemove}
    ></chat-panel-chip>`;
  }

  private _getTooltip(): string {
    const { name, sourceTableName, workflowId, source } = this.automation;
    const parts = [`Automation: ${name}`, `Source: ${source}`];
    if (sourceTableName) {
      parts.push(`Input: ${sourceTableName}`);
    }
    if (workflowId) {
      parts.push(`Workflow: ${workflowId}`);
    }
    return parts.join('\n');
  }

  private readonly _handleRemove = () => {
    this.onRemove?.(this.automation);
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'chat-panel-automation-chip': ChatPanelAutomationChip;
  }
}
